import React from 'react';
import Box from '@material-ui/core/Box';
import LinearProgress from '@material-ui/core/LinearProgress';
import { lighten, withStyles } from '@material-ui/core/styles';
import { ACTIVE_COLOR } from '../../utils/constants';

const BorderLinearProgress = withStyles({
    root: {
      height: 5,
      backgroundColor: lighten(ACTIVE_COLOR, 0.5),
    },
    bar: {
      borderRadius: 20,
      backgroundColor: ACTIVE_COLOR,
    },
  })(LinearProgress);
const Loading = () => {
    return (
        <Box height="100vh">
            <BorderLinearProgress />
        </Box>
    )
}

export default Loading;
